import css from './FragmentInfoFooterStep2.module.css';
import React from 'react';
import { FormatNumber } from '@shared/Helpers/FormatValue/FormatNumber/FormatNumber';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { useParams } from 'react-router-dom';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { CustomProjectStep2ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep2ElementsIdsEnum';
import classNames from 'classnames';

interface Props {
    totalPrice: number;
    isDisabled?: boolean;
    onSave: () => void;
}

export const FragmentInfoFooterStep2: React.FC<Props> = ({
    totalPrice,
    onSave,
    isDisabled = false,
}) => {
    const { viewMode } = useParams();
    return (
        <div
            className={css.fragmentFooter}
            id={CustomProjectStep2ElementsIdsEnum.WORK_AREA_STEP2_FOOTER}
        >
            <div className={css.totalPrice}>
                <div className={css.total}>Total</div>
                <div className={css.price}>
                    R {FormatNumber(totalPrice, '0.00')}
                </div>
            </div>

            <BasicButton
                isLoading={isDisabled}
                onClick={onSave}
                disabled={isDisabled}
                id={
                    CustomProjectStep2ElementsIdsEnum.WORK_AREA_STEP2_SAVE_PRODUCTS_BUTTON
                }
                extraClassName={classNames(css.fragmentFooterBtn, {
                    [css.disabled]: viewMode === StepsViewModeEnum.PRESENTATION,
                })}
            >
                Save
            </BasicButton>
        </div>
    );
};
